// extracted by mini-css-extract-plugin
module.exports = {"container":"aax_e","arrow":"aax_qk","containerCategoryStyle":"aax_aay"};